import React from "react";

const StatCard = ({
  action,
  icon,
  bgIconColor = "",
  title,
  value,
  footer,
  tag = null,
  progress = null,
  button = null,
}) => {
  const iconContainer = `flex items-center justify-center rounded-xl ${bgIconColor}`;

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm transition-shadow duration-200 hover:shadow-md">
     <div className="mb-3 flex items-center justify-between">
  <div className={`${iconContainer} h-10 w-10`}>{icon}</div>

  <div className="flex items-center gap-2">
    {tag}

    {button && (
      <button
        type="button"
        onClick={action}
        className={`${iconContainer} h-8 w-8 transition-transform duration-200 hover:scale-105 active:scale-95`}
      >
        {button}
      </button>
    )}
  </div>
</div>

      <div className="mb-2 flex items-end gap-1">
        <span className="truncate text-lg font-bold text-gray-900 md:text-2xl">
          {value}
        </span>

        {title && <span className="pb-0.5 text-sm text-gray-500">{title}</span>}
      </div>

      {progress !== null && (
        <div className="mb-2 h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
          <div
            className="h-full rounded-full bg-gradient-to-r from-primary to-blue-500 transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}

      {footer && <p className="truncate text-xs text-gray-400">{footer}</p>}
    </div>
  );
};

export default StatCard;
